/* SAM cart drawer - klikfilter.
   Bepaalt welke knoppen wel en niet als "toevoegen aan winkelwagen"
   gelden. Los bestand zodat dit aan te passen is zonder de cart-logica
   te raken. Geeft true terug als sam-cart.js de klik mag afvangen. */
(function () {
  var SKIP_CLOSEST = [
    ".shopify-payment-button",
    "[data-shopify=payment-button]",
    "shopify-accelerated-checkout",
    "shopify-accelerated-checkout-cart",
    ".dynamic-checkout__content",
    ".additional-checkout-buttons",
    ".shopify-cleanslate"
  ].join(",");

  window.SAMCartIsAddButton = function (btn, form) {
    if (!btn || !form) { return false; }

    /* Directe-betaalknoppen (Apple Pay, Shop Pay, PayPal) nooit afvangen. */
    if (btn.closest(SKIP_CLOSEST)) { return false; }

    /* Alleen echte verzendknoppen. Aantal-steppers, variantkeuzes en
       andere type="button" elementen in hetzelfde formulier overslaan. */
    var type = (btn.getAttribute("type") || "").toLowerCase();
    if (type && type !== "submit") { return false; }
    if (!type && btn.tagName !== "BUTTON") { return false; }

    /* Knoppen die naar de kassa gaan in plaats van toevoegen. */
    var name = (btn.getAttribute("name") || "").toLowerCase();
    if (name === "checkout" || name === "update" || name === "clear") { return false; }

    return true;
  };
})();